import React, { useEffect, useState } from "react";
import { AthleteLinks } from "../../../../parts/athlete-links";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import NavigationComponent from "../components/NavigationComponent";
import getAvatarUrl from "../../../../utils/get-avatar-url";
const views = {
  list: "List",
  timeline: "Timeline",
};
const ProgressPhotos = ({ locals, children }) => {
  const { athlete, query, pathname } = locals;

  return (
    <main role="reports-wrapper" id="progress-photos">
      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athlete}
          pathName={pathname}
          classNames={"only-show-mobile"}
          query={query}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(locals?.athlete?._id)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>
      <NavigationComponent
        query={query}
        text="Calendar Day View"
        pathName={pathname}
        classNames="mobile-hidden"
      />
      {children}
    </main>
  );
};

export default ProgressPhotos;
